import { LeadProvider, useLeadState } from "./lead-context";
import { Header } from "./Header";
import { Hero } from "./Hero";
import { Manifesto } from "./Manifesto";
import { Features } from "./Features";
import { EditorialMarquee } from "./Marquee";
import { Gallery } from "./Gallery";
import { Calculator } from "./Calculator";
import { Pricing } from "./Pricing";
import { FAQ } from "./FAQ";
import { Footer } from "./Footer";
import { LeadForm } from "./LeadForm";

export default function Landing() {
  const lead = useLeadState();
  return (
    <LeadProvider value={lead}>
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Features />
        <EditorialMarquee />
        <Gallery />
        <Calculator />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <LeadForm
        open={lead.open}
        setOpen={lead.setOpen}
        interest={lead.interest}
        setInterest={lead.setInterest}
      />
    </LeadProvider>
  );
}
